import { render, staticRenderFns } from "./QueryReceipt.vue?vue&type=template&id=624af85c&"
import script from "./QueryReceipt.vue?vue&type=script&lang=js&"
export * from "./QueryReceipt.vue?vue&type=script&lang=js&"
import style0 from "./QueryReceipt.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports